export default __webpack_public_path__ + "static/media/indicator-quote4.54d00c65.svg";